module.exports = __webpack_public_path__ + "img/refer-2.526d04d0.svg";